var map = {
	"./L&T2.png": 775,
	"./L&T_Infotech_logo.png": 6231,
	"./NTT Data.png": 799,
	"./accenture.png": 1765,
	"./atos syntel.png": 7491,
	"./capgemini.png": 1740,
	"./cognizant.png": 4252,
	"./cyient.png": 3002,
	"./dell.png": 7010,
	"./genpact.png": 9324,
	"./hcl.png": 8058,
	"./hexaware.png": 2310,
	"./infosys.png": 6284,
	"./itc.png": 532,
	"./mindfire.png": 6552,
	"./mindtree.png": 718,
	"./mphasis.png": 7468,
	"./niit.png": 6872,
	"./nokia.png": 44,
	"./persistent.png": 4558,
	"./rolta.png": 8195,
	"./sonata.png": 7597,
	"./tata.png": 7260,
	"./tcs.png": 2625,
	"./techmahindra.png": 4702,
	"./virtusa.png": 1405,
	"./wipro.png": 251,
	"./wns.png": 8850,
	"./zensar.png": 8498,
	"./zoho.png": 7770
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4578;